<template>
	<!-- 我的 -->
	<div class="all_main">
		<div class="right">
			<van-badge :content="
          $store.state.messageCount > 0 ? $store.state.messageCount : ''
        " max="99" style="width: 1.2rem; height: 1.2rem; margin: 0.5rem" @click.native="toMessageList()">
				<img src="@/assets/images/u414.png" style="width: 1rem; heiht: 1rem" />
			</van-badge>
		</div>
		<div style="padding-bottom: 3rem">
			<div class="backgroundC_main" style="height: 7rem; padding: 1rem 1rem; position: relative"
				@click="toUserInfo()">
				<div class="all_height20" style="display: flex">
					<span class="text16 all_line_height20 textcolorwhite font_weight_900 display_inline_block"
						style="width: 30%">{{ $store.state.userInfo.staffName }}</span>
					<span class="text10 all_height_line12 all_text_center" @click.stop="toAuth()" style="
              width: 20%;
              display: flex;
              background-color: #f0faf2;
              border-radius: 0.2rem;
              margin: 0.4rem 0;
            " :class="{
              passed: $store.state.userInfo.certifyState === 2,
              nopassed: $store.state.userInfo.certifyState != 2,
            }">
						{{
              $store.state.userInfo.certifyState != 2 ? "未认证" : "已认证"
            }}</span>
					<span style="
              width: 1.2rem;
              height: 1.2rem;
              margin: 0.4rem 2rem;
              background-color: #f0faf2;
              border-radius: 0.2rem;
            " @click.stop="toGreenLife()">
						<img src="@/assets/images/greenLife.svg" style="
                width: 0.8rem;
                height: 0.6rem;
                margin: 0.3rem 0.2rem;
                object-fit: fill;
              " />
					</span>
				</div>
				<div class="text14 textcolorwhite all_line_height14">
					{{
            $store.state.userInfo.mobile
              ? $store.state.userInfo.mobile.replace(
                  /^(\d{3})\d+(\d{4})$/,
                  "$1****$2"
                )
              : ""
          }}
				</div>
				<div class="text14 textcolorwhite all_line_height14">
					<span>{{ "账号：" + $store.state.userInfo.userName }}</span>
					<span style="margin-left: 2rem">{{
            $store.state.userInfo.staffTypeText
          }}</span>
				</div>
				<img style="position: absolute; top: 3rem;right:1.3rem;width: 1.4rem,height:1.4rem;"
					src="@/assets/images/u359.png" />
			</div>
			<div class="signature" v-if="$store.state.userInfo.certifyState != 0">
				<div style="height: 2rem">
					<span class="text14 textcolor333"
						style="line-height: 2rem; margin-left: 0.5rem">个人签名&nbsp;-&nbsp;</span>
					<span class="text14 textcolor333" style="line-height: 2rem"
						:style="{ color: textcolor }">{{ signatureStatus }}</span>
					<span v-if="
              $store.state.userInfo.signature &&
              $store.state.userInfo.signature.status === 3
            " style="line-height: 2rem" class="text10 textcolorNopass">
						&nbsp;:&nbsp;{{ $store.state.userInfo.signature.auditMemo }}</span>
					<img v-if="isEdit" src="@/assets/images/menu.svg" style="width: 1rem; margin: 0.5rem; float: right"
						@click="showBottom = true" />
				</div>
				<div style="width: 100%; text-align: center; padding-bottom: 1rem">
					<img :src="signatureFileBase64" style="
              width: 11rem;
              height: 4rem;
              margin: 0.5rem;
              object-fit: contain;
            " @click="addSignature()" />
				</div>
			</div>
			<div class="all_height_line24 margin_top_10 backgroundC_white display_flex bwhite_ative"
				@click="agreementPrivacyClick()">
				<span class="text14 textcolor333 all_line_height24 display_inline_block"
					style="width: 90%; padding-left: 0.8rem">隐私政策声明</span>
				<img src="@/assets/images/u359.png" style="height: 0.8rem; margin: 0.8rem" />
			</div>
			<div class="all_height_line24 backgroundC_white display_flex bwhite_ative" @click="agreementUserClick()">
				<span class="text14 textcolor333 all_line_height24 display_inline_block"
					style="width: 90%; padding-left: 0.8rem">服务协议</span>
				<img src="@/assets/images/u359.png" style="height: 0.8rem; margin: 0.8rem" />
			</div>
			<div class="all_height_line24 margin_top_10 backgroundC_white display_flex bwhite_ative"
				@click="settingsClick()">
				<span class="text14 textcolor333 all_line_height24 display_inline_block"
					style="width: 90%; padding-left: 0.8rem">设置</span>
				<img src="@/assets/images/u359.png" style="height: 0.8rem; margin: 0.8rem" />
			</div>
			<div class="all_height_line24 backgroundC_white display_flex bwhite_ative" @click="aboutClick()">
				<span class="text14 textcolor333 all_line_height24 display_inline_block"
					style="width: 90%; padding-left: 0.8rem">关于</span>
				<img src="@/assets/images/u359.png" style="height: 0.8rem; margin: 0.8rem" />
			</div>
		</div>
		<van-popup v-model:show="showBottom" position="bottom">
			<div class="signatureTool">
				<div class="horizontal_line"></div>
				<div v-if="hasSignature">
					<div class="text text14 textcolor666 backgroundC_white bwhite_ative" @click="deleteSignature()">
						删&nbsp;除
					</div>
					<div class="horizontal_line"></div>
				</div>
				<div v-else>
					<div class="text text14 textcolor666 backgroundC_white bwhite_ative" @click="write()">
						手写签名
					</div>
					<div class="horizontal_line"></div>
					<div class="text text14 textcolor666 backgroundC_white bwhite_ative" @click="jump()">
						上传签名照片
					</div>
					<div class="horizontal_line"></div>
					<div class="text text14 textcolor666 backgroundC_white bwhite_ative" @click="create()">
						一键生成签名
					</div>
					<div class="horizontal_line"></div>
				</div>
				<div style="height: 0.5rem; background-color: #ededed"></div>
				<div class="horizontal_line"></div>
				<div class="all_height_line24 text text14 textcolor999" @click="showBottom = false">
					取&nbsp;消
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Dialog,
		Badge,
	} from 'vant';
	export default {
		name: 'user',
		components: {
			[Badge.name]: Badge,
			[Dialog.name]: Dialog,
		},
		data() {
			return {
				//是否有签名
				hasSignature: false,
				//审核中不能修改
				isEdit: false,
				//弹窗
				showBottom: false,
				//个人信息
				userInfo: '',
				//个人签名base64
				signatureFileBase64: require('../../assets/images/add_signature.svg'),
				//状态颜色
				textcolor: '#333',
				//状态文字
				signatureStatus: '',
			};
		},
		activated() {
			console.log('user-activated')
			this.getUserInfo()
			this.showBottom = false
		},
		methods: {
			//个人认证
			toAuth() {
				// this.$router.push({
				// 	path: '/personalauthflow',
				// });
				// return
				//console.log('---toAuth---=',this.$store.state.userInfo)
				if (this.$store.state.userInfo.certifyState !== 2) {
					this.$router.push({
						path: '/personalauthflow',
					});
				}
			},
			//
			toGreenLife() {
				this.$router.push({
					path: '/energyconservationselfoverview',
				});
			},
			//certifyWay 认证方式、certifyState 认证状态、staffStatus：人员状态
			// certifyState：认证状态
			// NONE(0, "未认证"),
			// CERTIFYING(1, "认证中"),
			// PASSED(2, "已通过"),
			// DENIED(3, "不通过");
			// certifyWay：认证方式
			// UNKNOWN(0, "未指定"),
			// FACE_CARD(1, "扫脸+银行卡"),
			// FACE_MOBILE(2, "扫脸+手机号"),
			// FACE(3, "人脸"),
			// MOBILE(4, "短信"),
			// CARD(5, "银行卡");
			// staffStatus：人员状态
			// CERTIFYING(1, "认证中"),
			// CERTIFIED(2, "已认证"),
			// DISCARDED(3, "已注销");
			//获取个人信息
			getUserInfo() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$post("/my/api/getDetailForMobile")
					.then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success && res.data) {
							this.userInfo = res.data
							this.$store.dispatch("actionUserInfo", res.data);
							if (this.userInfo.signature) {
								this.signatureFileBase64 = 'data:image/png;base64,' + this.userInfo.signature.fileData
								this.hasSignature = this.Tool.isNoEmpty(this.signatureFileBase64)
								this.isEdit = this.userInfo.signature.status != 1
								switch (this.userInfo.signature.status) {
									case 1:
										this.signatureStatus = '审核中'
										this.textcolor = '#F59A23'
										break;
									case 2:
										this.signatureStatus = '使用中'
										this.textcolor = '#70B603'
										break;
									case 3:
										this.signatureStatus = '未通过'
										this.textcolor = '#D9001B'
										break;
								}
							} else {
								this.isEdit = false
								this.signatureStatus = ''
								this.signatureFileBase64 = require('../../assets/images/add_signature.svg')
								this.hasSignature = false
							}
						} else {
							this.$Toast(res.message || "获取信息失败！");
							this.userInfo = ''
							this.hasSignature = false
						}
					});
			},
			//删除签名
			deleteSignature() {
				var that = this
				this.showBottom = false
				if (this.signatureFileBase64) {
					Dialog.confirm({
							title: '提示',
							message: '确定删除当前签名？',
							confirmButtonText: '确定',
							confirmButtonColor: '#0277FC'
						})
						.then(() => {
							that.$store.dispatch(that.$LoadShow, true)
							that.$post('/my/api/removeSignature?signatureId=' + that.userInfo.signature.signatureId)
								.then((res) => {
									that.$store.dispatch(that.$LoadShow, false)
									if (res.success) {
										that.$Toast("删除成功！");
										that.signatureFileBase64 = ''
										that.hasSignature = false
										that.getUserInfo()
									} else {
										that.$Toast(res.message || "删除失败！");
									}
								});
						})
						.catch(() => {
							// on cancel
						});
				} else {
					this.$Toast("您还没有个人签名！");
				}
			},
			//是否弹出弹窗
			addSignature() {
				if (!this.isEdit && !this.userInfo.signature) {
					this.showBottom = true
				}
			},
			//上传
			jump() {
				this.showBottom = false
				this.$router.push({
					path: '/uploadsignature'
				})
			},
			//生成
			create() {
				this.showBottom = false
				this.$router.push({
					path: '/createsignature'
				})
			},
			//手写
			write() {
				this.showBottom = false
				this.$router.push({
					path: '/writesignaturepad'
				})
			},
			//个人信息页面
			toUserInfo() {
				this.$router.push({
					path: '/userinfo',
				});
			},
			//跳转消息列表页面
			toMessageList() {
				// if (this.$store.state.messageCount > 0) {
				// 	this.$router.push({
				// 		path: '/newsList',
				// 	});
				// }
				this.$router.push({
					path: '/newsList',
				});
			},
			//签名管理
			signatureClick() {
				if (this.$store.state.userInfo.certifyState === 0) {
					this.$Toast('请先进行个人认证!')
					return
				}
				this.$router.push({
					path: '/esignature',
				});
			},
			//设置
			settingsClick() {
				this.$router.push({
					path: '/settings',
				});
			},
			//关于
			aboutClick() {
				this.$router.push({
					path: '/about',
				})
			},
			//用户协议
			agreementUserClick() {
				this.$router.push({
					name: 'agreementdetails',
					params: {
						type: 1,
					}
				})
			},
			//隐私政策
			agreementPrivacyClick() {
				this.$router.push({
					name: 'agreementdetails',
					params: {
						type: 2,
					}
				})
			},
			//
			init() {}
		},
		mounted() {
			//this.init()
			//console.log('user')
			this.getUserInfo()
		},
	};
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";

	.right {
		position: absolute;
		top: 1.8rem;
		right: 0.5rem;
		z-index: 10;
	}

	.passed {
		color: #66be74;
		border: 1px solid #66be74;
	}

	.passed::before {
		content: url("../../assets/images/personal_auth.svg");
		display: inline-block;
		width: 0.8rem;
		height: 0.8rem;
		margin-right: 0.3rem;
		transform: scale(0.5);
	}

	.nopassed {
		color: #df4545;
		border: 1px solid #df4545;
		justify-content: center;
	}

	.item {
		float: right;
	}

	.item::after {
		content: url("../../assets/images/u359.png");
		display: inline-block;
		width: 0.7rem;
		height: 1.4rem;
		line-height: 1.4rem;
		// margin: 0 .5rem;
	}

	.signature {
		margin: 1rem 0.4rem 0;
		border-radius: 0.3rem;
		background-color: white;
	}

	.signatureTool {
		.text {
			width: 100%;
			height: 2rem;
			line-height: 2rem;
			text-align: center;
		}
	}
</style>